// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/libraries.scss
// module id = ./resources/assets/sass/libraries.scss
// module chunks = 1